import React, { Component } from 'react';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, HelpBlock, Checkbox } from 'react-bootstrap'
import Select from "react-select";

import { StopAdditionalInfo } from './StopAdditionalInfo';

export class StopActiveForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            render: {
                showAdditionalInfo: false
            }
        };
    }

    // ---------------------

    onShowAdditionalInfo() {
        const { render } = this.state;

        render.showAdditionalInfo = true;

        this.setState({
            render: render
        });
    }

    onHideAdditionalInfo() {
        const { render } = this.state;

        render.showAdditionalInfo = false;

        this.setState({
            render: render
        });
    }

    // ---------------------

    render() {
        const { form } = this.props;

        if(undefined === form) {
            return null;
        }

        const { render } = this.state;
        const { show, interfaces } = this.props;

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>
                        {form.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formCode" validationState={form.codeInputError} >
                            <ControlLabel>Código</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.code}
                                placeholder="Introduza o código"
                                onChange={(e) => this.props.onChangeValue(e, "code")}
                            />
                            {form.codeInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formName" validationState={form.nameInputError}>
                            <ControlLabel>Nome</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.name}
                                placeholder="Introduza o nome"
                                onChange={(e) => this.props.onChangeValue(e, "name")}
                            />
                            {form.nameInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formShortName">
                            <ControlLabel>Abreviatura</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.shortName}
                                placeholder="Introduza a abreviatura"
                                onChange={(e) => this.props.onChangeValue(e, "shortName")}
                            />
                        </FormGroup>

                        <FormGroup controlId="formExtCode">
                            <ControlLabel>Código Externo</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.extCode}
                                placeholder="Introduza o código externo"
                                onChange={(e) => this.props.onChangeValue(e, "extCode")}
                            />
                        </FormGroup>

                        <FormGroup controlId="formIsActive">
                            <Checkbox 
                                className="form-checkbox" 
                                defaultChecked={form.obj.isActive} 
                                onChange={(e) => this.props.onCheckValue(e, "isActive")}>
                                Paragem Ativa
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formLatitude" validationState={form.latitudeInputError}>
                            <ControlLabel>Latitude</ControlLabel>
                            <FormControl
                                type="number"
                                value={form.obj.latitude}
                                placeholder="Introduza a latitude"
                                onChange={(e) => this.props.onChangeValue(e, "latitude")}
                            />
                            {form.latitudeInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formLongitude" validationState={form.longitudeInputError}>
                            <ControlLabel>Longitude</ControlLabel>
                            <FormControl
                                type="number"
                                value={form.obj.longitude}
                                placeholder="Introduza a longitude"
                                onChange={(e) => this.props.onChangeValue(e, "longitude")}
                            />
                            {form.longitudeInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formInterfaces">
                            <ControlLabel>Interfaces</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Interfaces"
                                noOptionsMessage={() => "Sem Interfaces Configuradas"}
                                onChange={(e) => this.props.onSelectValue(e, "interfaces")}
                                options={interfaces}
                                isMulti={true}
                                isOptionSelected={function (a) {
                                    if (undefined !== form.obj.interfaces) {
                                        return form.obj.interfaces.includes(a.id);
                                    }
                                }}
                                getOptionValue={value => value.id}
                                getOptionLabel={label => label.namePt}
                                value={form.obj.interfaces}
                            />
                        </FormGroup>
                    </Form>

                    <ButtonToolbar>
                        <Button onClick={() => this.onShowAdditionalInfo()}> INFORMAÇÃO ADICIONAL </Button>
                        <Button onClick={() => this.props.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        {this.props.showDeleteButton ? <Button onClick={() => this.props.onDelete()}> ELIMINAR </Button> : null}
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>

                    <StopAdditionalInfo
                        show={render.showAdditionalInfo}
                        onChangeValue={(a, b) => this.props.onCheckValue(a, b)}
                        onChangeSelectValue={(a, b) => this.props.onSelectValue(a, b)}
                        stopSelected={form.obj}
                        onHide={() => this.onHideAdditionalInfo()} />
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/stops/StopActiveForm.js